<template>
  <div :class="`form-element form-${type}-element`">
    <FormLabel
      :required="options.required"
      :title="options.title"
      :filled="internalValue !== undefined && internalValue !== null"
      :field-type="type"
    />
    <v-row>
      <v-col
        v-if="options.type !== 'time'"
        class="py-0"
      >
        <v-dialog
          ref="dateDialog"
          v-model="dataDialogOpen"
          :return-value.sync="internalDateValue"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              class="pt-0"
              :value="formatDate(internalDateValue)"
              prepend-icon="mdi-calendar"
              readonly
              hide-details
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="internalDateValue"
            scrollable
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="dataDialogOpen = false"
            >
              {{ $t('misc.cancel') }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dateDialog.save(internalDateValue)"
            >
              {{ $t('misc.ok') }}
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col
        v-if="options.type === 'time' || options.type === 'datetime'"
        class="py-0"
      >
        <v-dialog
          v-if="isMobile"
          ref="timeDialog"
          v-model="timeDialogOpen"
          :return-value.sync="internalTimeValue"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="internalTimeValue"
              class="py-0"
              prepend-icon="mdi-clock"
              readonly
              hide-details
              v-on="on"
            />
          </template>
          <v-time-picker
            v-if="timeDialogOpen"
            v-model="internalTimeValue"
            full-width
            format="24hr"
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="timeDialogOpen = false"
            >
              {{ $t('misc.cancel') }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.timeDialog.save(internalTimeValue)"
            >
              {{ $t('misc.ok') }}
            </v-btn>
          </v-time-picker>
        </v-dialog>
        <VCleaveInput
          v-else
          v-model="internalCleaveTimeValue"
          class="pt-0"
          :options="timeCleaveOptions"
          placeholder="HH:MM"
          hide-details
          prepend-icon="mdi-clock"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VCleaveInput from "vuetify-cleave";
import FormLabel from '../FormLabel';

export default {
  components: {
    FormLabel,
    VCleaveInput
  },
  props: {
    value: { type: [String, Object], default: null },
    type: { type: String, required: true },
    options: { type: Object, default: () => ({}) }
  },
  data: () => ({
    timeCleaveOptions: {
      time: true,
      timePattern: ['h', 'm']
    },
    dataDialogOpen: false,
    timeDialogOpen: false,
    datePart: null,
    timePart: null
  }),
  computed: {
    internalValue: {
      get () {
        return (this.value && this.value instanceof Object) ? this.value : {
          time: null,
          date: null
        };
      },
      set (v) {
        this.$emit('input', v);
      }
    },
    internalDateValue: {
      get () {
        return this.internalValue.date;
      },
      set (v) {
        this.internalValue.date = v;
        this.$emit('input', this.internalValue);
      }
    },
    internalTimeValue: {
      get () {
        return this.internalValue.time;
      },
      set (v) {
        this.internalValue.time = v;
        this.$emit('input', this.internalValue);
      }
    },
    internalCleaveTimeValue: {
      get () {
        let time = this.internalValue.time;
        if (!time) return null;

        return time.split(':').join("");
      },
      set (v) {
        if (!v || v.length < 4) {
          this.internalValue.time = null;
        } else {
          const hour = v.substr(0, 2);
          const minute = v.substr(2, 2);
          this.internalValue.time = `${hour}:${minute}`;
        }

        this.$emit('input', this.internalValue);
      }
    },
    isMobile () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
      );
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    }
  }
};
</script>
